<template>
    <div class="day-image">
        <img v-if="imageUrl" :src="imageUrl" alt="" />
        <div v-else class="no-event">{{ $translate('no_image') }}</div>
    </div>
</template>

<script>
export default {
    name: 'DayImage',
    props: {
        imageUrl: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.day-image {
    position: relative;
    padding: 5px;
    display: grid;
    place-items: center;

    img {
        @media screen {
            width: 100%;
        }
        @media print {
            width: 90%; // strange bug changing proportions in printed version
        }
    }
}
</style>
